{
  "nav": {
    "submissions": "Submissions",
    "tenants": "Tenants"
  },
  "submissions": {
    "title": "Submissions",
    "filters": {
      "status": "Status",
      "statusSubmitted": "Awaiting evaluation",
      "statusEvaluated": "Evaluated",
      "statusAll": "All",
      "tenant": "Workspace",
      "tenantAll": "All workspaces",
      "respondent": "Respondent",
      "respondentPlaceholder": "Search by respondent email",
      "sort": "Order",
      "oldestFirst": "Oldest first",
      "newestFirst": "Newest first"
    },
    "table": {
      "tenant": "Workspace",
      "respondent": "Respondent",
      "submitted": "Submitted",
      "status": "Status",
      "evaluation": "Evaluation",
      "self": "Self-profile",
      "empty": "No submissions found."
    }
  },
  "evaluationState": {
    "draft": "Draft",
    "published": "Published"
  },
  "detail": {
    "back": "Back to submissions",
    "notFound": "Submission not found.",
    "tenant": "Workspace",
    "givenName": "Given name",
    "familyName": "Family name",
    "email": "Email",
    "submitted": "Submitted",
    "language": "Language",
    "selfAssignment": "Self-profile",
    "briefHint": "The commissioning purpose — write the evaluation with it in view.",
    "matrix": "Matrix",
    "copyForAnalysis": "Copy for analysis",
    "copyHint": "Puts the grid, its totals and its dispersion figures on the clipboard as structured data.",
    "copied": "Grid copied for analysis.",
    "copyFailed": "Could not copy the grid to the clipboard.",
    "downloadData": "Download data (.xlsx)",
    "downloadHint": "The raw answers in Pam's three-set layout, the crosstab they sum to, and the grid with its aggregates.",
    "downloadFailed": "Could not build the workbook."
  },
  "editor": {
    "title": "Evaluation",
    "placeholder": "Write the evaluation…",
    "saving": "Saving…",
    "savedAt": "Saved at {{time}}",
    "saveDraft": "Save draft",
    "publish": "Publish",
    "publishConfirmTitle": "Publish this evaluation?",
    "publishConfirmDescription": "Publishing notifies the workspace and the respondent, and cannot be undone.",
    "publishOptions": "More publish options",
    "publishSilently": "Publish silently",
    "publishSilentlyConfirmTitle": "Publish this evaluation silently?",
    "publishSilentlyConfirmDescription": "No one will be notified, by email or in the app. Use this only for an evaluation already sent to the workspace another way. Publishing cannot be undone.",
    "published": "Published",
    "publishedAt": "Published {{date}}",
    "publishedBy": "by {{name}}"
  },
  "tenants": {
    "title": "Tenants",
    "table": {
      "name": "Name",
      "slug": "Slug",
      "locale": "Default language",
      "created": "Created",
      "owners": "Owners",
      "users": "Users",
      "submissions": "Submissions",
      "credits": "Credits",
      "actions": "Actions",
      "gifted": "{{granted}} gifted",
      "empty": "No workspaces found."
    },
    "grant": {
      "action": "Grant credits",
      "title": "Grant credits to {{name}}",
      "description": "Gift free credits to this workspace. No payment is taken and no invoice is raised. The reason is for our records only and is never shown to the workspace.",
      "creditsLabel": "Credits",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "e.g. Sales trial — Acme",
      "submit": "Grant credits",
      "success": "Credits gifted."
    }
  }
}
